/* WR CART RECS — fills every [data-wr-cart-recs] slot (cart drawer + cart page)
   with recommendations for the most recently added cart item, via the Section
   Rendering API (section: wr-cart-recs). intent=complementary first (uses
   Search & Discovery pairings when configured), falls back to the algorithmic
   intent=related. Refreshes after any cart mutation. Fails silent.

   REFORMER ANCHOR (2026-07-10): if the cart contains a reformer, recs are
   fetched anchored to THAT reformer's product_id (not just the newest line)
   — the merchant-configured "complementary" pairings for jump boards/boxes/
   mats live on the reformer's own PDP, so anchoring there surfaces the right
   candidate pool. sections/wr-cart-recs.liquid then hard-filters that pool
   to accessories and never shows another reformer or a sauna. */
(function () {
  'use strict';
  if (window.__wrCartRecs) return;
  window.__wrCartRecs = true;

  var BUSY = false;
  var LAST_PID = null;

  function slots() {
    return document.querySelectorAll('[data-wr-cart-recs]');
  }

  function inject(html) {
    var tpl = document.createElement('template');
    tpl.innerHTML = html;
    var content = tpl.content.querySelector('.complementary-products');
    slots().forEach(function (slot) {
      slot.innerHTML = content ? content.outerHTML : '';
    });
  }

  function fetchSection(pid, intent) {
    return fetch(
      '/recommendations/products?section_id=wr-cart-recs&product_id=' +
        pid + '&limit=8&intent=' + intent
    )
      .then(function (r) { return r.ok ? r.text() : ''; })
      /* network failure (offline/abort) resolves to empty instead of
         rejecting — otherwise the rejection escapes refresh()'s outer
         catch and BUSY stays true, freezing recs until reload. */
      .catch(function () { return ''; });
  }

  function refresh() {
    if (BUSY || !slots().length) return;
    BUSY = true;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) {
          inject('');
          BUSY = false;
          return;
        }
        /* prefer anchoring on a reformer already in the cart — its PDP is
           where "complete your setup" accessory pairings are configured */
        var reformerItem = cart.items.filter(function (item) {
          var type = (item.product_type || '').toLowerCase();
          return type.indexOf('reformer') !== -1 || type.indexOf('megaformer') !== -1;
        })[0];
        var pid = (reformerItem || cart.items[0]).product_id; /* else newest line first */
        LAST_PID = pid;
        fetchSection(pid, 'complementary').then(function (html) {
          if (html && html.indexOf('data-wr-recs-count') !== -1) {
            inject(html);
            BUSY = false;
          } else {
            fetchSection(pid, 'related').then(function (html2) {
              inject(html2 && html2.indexOf('data-wr-recs-count') !== -1 ? html2 : '');
              BUSY = false;
            });
          }
        });
      })
      .catch(function () { BUSY = false; });
  }

  /* re-render after any cart mutation */
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(refresh, 350); });
    }
    return p;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  /* QUICK-BUY BUTTON STATE (2026-07-10) — "Adding"/"Added" text feedback
     on product-card-horizontal's add-to-cart buttons: cart drawer + cart
     page recs widget AND PDP complementary products (same shared snippet,
     see assets/wr-cart-drawer.css for the pill styling). Purely cosmetic —
     mirrors Prestige's own add-to-cart lifecycle (aria-busy while in
     flight, then cart:change on success / cart:error on failure, see
     assets/theme.js ProductForm) onto the button label. Never touches the
     actual add-to-cart fetch. Delegated on document so it keeps working
     after inject() replaces the recs widget markup, or after any other
     re-render of a complementary-products list. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.horizontal-product-card button[type="submit"]');
    if (!btn) return;
    var card = btn.closest('.horizontal-product-card');
    if (!card) return;
    var buttons = card.querySelectorAll('button[type="submit"]');
    if (!buttons.length) return;

    buttons.forEach(function (b) {
      if (!b.dataset.wrQbLabel) b.dataset.wrQbLabel = b.textContent.trim();
      b.textContent = 'Adding';
    });

    var settled = false;
    var finish = function (added) {
      if (settled) return;
      settled = true;
      document.removeEventListener('cart:change', onChange);
      document.removeEventListener('cart:error', onError);
      buttons.forEach(function (b) {
        b.textContent = added ? 'Added' : b.dataset.wrQbLabel;
      });
    };
    var onChange = function () { finish(true); };
    var onError = function () { finish(false); };
    document.addEventListener('cart:change', onChange);
    document.addEventListener('cart:error', onError);
    /* safety net: never leave a button stuck on "Adding" (offline, aborted
       fetch...) — matches Prestige's own request lifecycle, doesn't fire
       under normal conditions since cart:change/cart:error always resolve
       the pending add-to-cart fetch first. */
    setTimeout(function () { finish(false); }, 6000);
  });
})();
